"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = KevelBannerPreviewer;
const react_1 = __importDefault(require("react"));
const BannerErrors_1 = __importDefault(require("./BannerErrors/BannerErrors"));
const AppHomeCarouselBannerPreviewer_1 = __importDefault(require("./AppHomeCarouselBannerPreviewer/AppHomeCarouselBannerPreviewer"));
function KevelBannerPreviewer(props) {
    const { errors } = props;
    if (errors && errors.length > 0) {
        return react_1.default.createElement(BannerErrors_1.default, { errors: errors });
    }
    let banner = null;
    let BannerPreviewer = null;
    switch (props.placement) {
        case "Home":
            banner = props.home;
            BannerPreviewer = AppHomeCarouselBannerPreviewer_1.default;
            break;
        default:
            break;
    }
    if (banner && BannerPreviewer) {
        return react_1.default.createElement(BannerPreviewer, Object.assign({}, banner));
    }
    return null;
}
